<template>
  <div class="mt-2">
    <div v-if="product">
      <v-layout>
        <v-flex>
          <v-btn flat @click="cancelContent">
            <i class="fas fa-chevron-left mr-1"></i>
            {{ $t('Back') }}
          </v-btn>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn depressed color="primary" @click="saveProduct">{{ $t('Save') }}</v-btn>
        </v-flex>
      </v-layout>

      <h2 class=" mt-3">{{ $t('Edit Product') }}</h2>

      <div class="form-control mt-3" :class="{ 'has-error': errors.has('categoryInput') }">
        <label class="caption" for="categoryInput">{{ $t('Category') }} *</label>
        <select-category
          :pageid="pageid"
          v-model="category"
          :selected="currentCategory"
          @onChangeCategory="onChangeCategory"
          data-vv-name="categoryInput"
          :data-vv-as="$t('Category')"
          v-validate="'required'"
        ></select-category>
        <p class="text-error" v-show="errors.has('categoryInput')">
          {{ errors.first('categoryInput') }}
        </p>
      </div>

      <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
        <upload-multiple-file
          v-model="productImages"
          :max="10"
          data-vv-name="uploadMultipleFile"
          data-vv-as="Preview Image"
        ></upload-multiple-file>

        <span class="text-error" v-show="errors.has('uploadMultipleFile')">{{
          errors.first('uploadMultipleFile')
        }}</span>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
        <label class="caption" for="nameInput">{{ $t('Product Name') }} *</label>
        <input
          type="text"
          class="form-control"
          ref="name"
          id="nameInput"
          name="nameInput"
          :data-vv-as="$t('Product Name')"
          aria-describedby="name"
          :placeholder="$t('Product Name')"
          v-model="product.name"
          v-validate="'required'"
          @blur="$set(product, 'name', noSpaceAndSpecial($event))"
        />
        <span class="text-error" v-show="errors.has('nameInput')">{{
          errors.first('nameInput')
        }}</span>
      </div>

      <template v-if="selectedBot.pageid != '114660513608160'">
        <div class="form-control" :class="{ 'has-error': errors.has('codeInput') }">
          <label class="caption" for="codeInput">{{ $t('SKU') }}</label>
          <input
            type="text"
            class="form-control"
            id="codeInput"
            name="codeInput"
            :data-vv-as="$t('SKU')"
            aria-describedby="SKU"
            :placeholder="$t('SKU')"
            v-model="product.code"
          />
          <span class="text-error" v-show="errors.has('codeInput')">{{
            errors.first('codeInput')
          }}</span>
        </div>
      </template>

      <div class="form-control" :class="{ 'has-error': errors.has('priceInput') }">
        <label class="caption" for="priceInput">{{ $t('Price') }} *</label>
        <div class="form-inline">
          <div
            style="
              padding: 6px 12px;
              border-radius: 50%;
              display: inline-block;
              background: #eee;
              margin-right: 5px;
            "
          >
            {{ currencySign }}
          </div>
          <input
            type="text"
            class="form-control"
            id="priceInput"
            name="priceInput"
            :data-vv-as="$t('Price')"
            ref="price"
            aria-describedby="price"
            :placeholder="$t('Price')"
            v-model="product.price"
            v-validate="'required|decimal|min_value:1'"
            style="max-width: 150px; display: inline"
            @blur="
              $set(product, 'price', decimalOnly($event))
              onChangePrice()
            "
          />
          &nbsp;
          <span class="text-error" v-show="errors.has('priceInput')">{{
            errors.first('priceInput')
          }}</span>
        </div>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('discountPriceInput') }">
        <label class="caption" for="dicountPriceInput">{{ $t('Sale price') }} *</label>
        <div class="form-inline">
          <div
            style="
              padding: 6px 12px;
              border-radius: 50%;
              display: inline-block;
              background: #eee;
              margin-right: 5px;
            "
          >
            {{ currencySign }}
          </div>
          <input
            type="text"
            class="form-control"
            id="discountPriceInput"
            name="discountPriceInput"
            :data-vv-as="$t('Sale price')"
            aria-describedby="Sale Price"
            :placeholder="$t('Sale price')"
            v-model="product.discountprice"
            v-validate="'required|decimal|min_value:1|isLessThanOrEqual:price'"
            style="max-width: 150px; display: inline"
            @blur="$set(product, 'discountprice', decimalOnly($event))"
          />
          <div
            class="text-xs-center"
            v-if="
              product.discountprice &&
                parseFloat(product.discountprice) > 0 &&
                parseFloat(product.price) > parseFloat(product.discountprice)
            "
            style="padding: 5px 10px; background: red; color: white; display: inline-block"
          >
            {{ (((product.price - product.discountprice) / product.price) * 100) | numberFormat }}%
          </div>
          <div
            class="text-xs-center"
            v-else
            style="padding: 5px 10px; background: #eee; color: white; display: inline-block"
          >
            0%
          </div>
          <div>
            <span class="text-error" v-show="errors.has('discountPriceInput')">{{
              errors.first('discountPriceInput')
            }}</span>
          </div>
        </div>
      </div>

      <div class="form-control" :class="{ 'has-error': errors.has('costInput') }" v-if="enableProductCost">
        <label class="caption" for="costInput">{{ $t('Cost') }}</label>
        <div class="form-inline">
          <div
            style="
              padding: 6px 12px;
              border-radius: 50%;
              display: inline-block;
              background: #eee;
              margin-right: 5px;
            "
          >
            {{ currencySign }}
          </div>
          <input
            type="text"
            class="form-control"
            id="costInput"
            name="costInput"
            :data-vv-as="$t('Cost')"
            ref="cost"
            aria-describedby="cost"
            :placeholder="$t('Cost')"
            v-model="product.cost"
            v-validate="'decimal|min_value:1'"
            style="max-width: 150px; display: inline"
            @blur="$set(product, 'cost', decimalOnly($event))"
          />
          &nbsp;
          <span class="text-error" v-show="errors.has('costInput')">{{
            errors.first('costInput')
          }}</span>
        </div>
      </div>

      <template v-if="selectedBot.pageid != '114660513608160'">
        <div class="form-control" :class="{ 'has-error': errors.has('productWeightInput') }">
          <label class="caption" for="productWeightInput"
            >{{ $t('Product Weight') }} ({{ $t('gram') }})</label
          >
          <div>
            <input
              type="text"
              class="form-control"
              id="productWeightInput"
              name="productWeightInput"
              :data-vv-as="$t('Product Weight')"
              aria-describedby="productWeight"
              ref="productWeight"
              :placeholder="$t('Product Weight')"
              v-model="product.weight"
              v-validate="'decimal:2|min_value:0'"
            />
            <span class="text-error" v-show="errors.has('productWeightInput')">{{
              errors.first('productWeightInput')
            }}</span>
          </div>
        </div>
      </template>

      <div class="form-control" :class="{ 'has-error': errors.has('descriptionInput') }">
        <div>
          <label class="caption" for="nameInput">{{ $t('Product detail') }} *</label>
        </div>
        <textarea
          type="text"
          class="form-control"
          id="descriptionInput"
          style="resize: vertical; min-height: 90px; width: 100%"
          name="descriptionInput"
          :data-vv-as="$t('Product detail')"
          aria-describedby="description"
          :placeholder="$t('Product detail')"
          row="3"
          v-model="product.description"
          v-validate="'required'"
        ></textarea>
        <span class="text-error" v-show="errors.has('descriptionInput')">{{
          errors.first('descriptionInput')
        }}</span>
      </div>

      <template v-if="!loadingProductStock">
        <product-stock
          v-model="productstock"
          :category="productstockcategories"
          :product="product"
          @updateCategory="updateCategory"
          @deleteStock="deleteStock"
        ></product-stock>
      </template>
      <template v-if="selectedBot.pageid != '114660513608160'">
        <template v-if="!isLoadingBundle && $store.getters.getPackage == 'premium'">
          <h2>
            {{ $t('Wholesale') }}
            <a
              href="https://blog.zwiz.ai/%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%82%E0%B8%B2%E0%B8%A2%E0%B8%AA%E0%B9%88%E0%B8%87_shop-service/"
              target="blank"
              ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
            ></a>
          </h2>
          <product-bundle
            v-model="productbundle"
            @deleteBundle="deleteBundle"
            :price="product.price ? parseFloat(product.price) : 0"
          ></product-bundle>
        </template>
      </template>

      <!-- ลูกไก่ทอง -->
      <template v-if="check_privilege('vat')">
        <v-divider class="mt-4" />
        <div class="text-xs-center" style="margin-top: -10px;">
          <a href="javascript:void(0);" class="btn-advanced" @click="showAdvanced = !showAdvanced">
            {{ $t('Advanced') }}
            <i
              class="fa"
              :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
            ></i>
          </a>
        </div>

        <div v-if="showAdvanced">
          <v-radio-group v-model="product.vat_types" row>
            <v-radio label="No Vat" :value="null" color="primary"></v-radio>
            <v-radio label="Included vat" value="include" color="primary"></v-radio>
            <v-radio label="Excluded vat" value="exclude" color="primary"></v-radio>
          </v-radio-group>

          <!-- <div class="form-control" :class="{ 'has-error': errors.has('vat') }" v-if="['include', 'exclude'].includes(product.vat_types)">
              <div class="caption">Vat</div>
              <input
                type="number"
                name="vat"
                data-vv-as="Vat"
                v-model="product.vat_value"
                v-validate="'required'"
                maxlength="3"
                max="100"
                min="0"
              />
              <span class="error--text caption" v-show="errors.has('vat')">
                {{ errors.first('vat') }}
              </span>
            </div> -->
        </div>

        <div class="mb-4"></div>
      </template>

      <template v-if="$store.state.specialpage.includes(selectedBot.pageid)">
        <div class="hr" style="margin-top: 35px"></div>
        <template v-if="$store.getters.getPackage == 'premium'">
          <div class="text-xs-center" style="margin-top: -15px">
            <a
              class="btn-advanced"
              href="javascript:void(0);"
              @click="showAdvanced = !showAdvanced"
            >
              {{ $t('Advanced') }}
              <i
                class="fa"
                :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
              ></i>
            </a>
          </div>

          <template v-if="showAdvanced">
            <div class="row form-control" :class="{ 'has-error': errorTag.length > 0 }">
              <div class="col s12">
                <label class="caption" for="keywordInput">{{ $t('Keywords') }}</label>
                <tags
                  v-model="tag"
                  :tags="tags"
                  @tags-changed="newTags => (tags = newTags)"
                  @before-adding-tag="checkTag"
                />
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m6">
                <div
                  class="form-control"
                  v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                >
                  <label class="caption" for="buttonNameInput">{{ $t('Button Name') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonNameInput"
                    aria-describedby="Button Name"
                    :placeholder="$t('Button Name')"
                    v-model="product.buttonname"
                  />
                </div>
              </div>
              <div class="col s12 m6">
                <div class="form-control" v-if="product.buttonaction == 'url'">
                  <label class="caption" for="buttonUrlInput">{{ $t('Product Url') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="buttonUrlInput"
                    aria-describedby="Product Url"
                    :placeholder="$t('Product Url')"
                    v-model="product.buttonurl"
                  />
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>

      <div class="text-xs-center">
        <v-btn color="grey" outline @click="cancelContent()">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="saveProduct">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCategory from './SelectCategory'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import ProductStock from './ProductStock'

import ProductBundle from './ProductBundle'
import Tags from '@/components/elements/Tags'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import { cloneDeep } from 'lodash'

export default {
  props: ['value', 'category'],
  inject: ['$validator'],
  data: function() {
    return {
      productImages: [],
      product: null,
      currentCategory: this.value.categoryid,
      categories: null,
      tag: '',
      currentView: 'product',
      showAdvanced: false,
      deleteStockList: [],
      deleteBundleList: [],
      productstock: [],
      productbundle: [],

      loadingStock: null,
      loadingBundle: null,
      stock_process_count: 0,
      bundle_process_count: 0,
      productstockcategories: [],

      isLoadingBundle: true,

      errorTag: [],
      loadingProductStock: true,
      oldStock: [],
      enableProductCost: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currencySign: function() {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'
          case 'GBP':
            return '£'
          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },
    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join(',')
      }
    }
  },
  components: {
    SelectCategory,
    uploadfile: uploadfile,
    VueTagsInput,
    UploadMultipleFile,
    ProductStock,
    ProductBundle,
    Tags
  },
  mounted: async function() {
    let vm = this
    await this.$nextTick()
    goTo(0)
    vm.product = JSON.parse(JSON.stringify(vm.value))
    vm.product.buttonaction = 'url'
    vm.cached_product = JSON.stringify(vm.product)
    vm.loadingProductStock = true
    vm.productstock = []
    var productstock = vm.value.productstock.map(el => {
      return [...el]
    })
    this.oldStock = vm.value.productstock.map(el => {
      return el[0]
    })
    vm.productstock = productstock
    await vm.$nextTick()
    vm.loadingProductStock = false

    try {
      vm.productstockcategories = JSON.parse(vm.product.productstockcategories)
    } catch (error) {}
    vm.cached_productstock = JSON.stringify(vm.value.productstock)

    vm.productImages = vm.product.photourl ? vm.product.photourl.split(';;') : []

    if (vm.productImages.length > 0) {
      vm.productImages.map(function(val, index) {
        if (val == '') {
          vm.productImages.splice(index, 1)
        }
      })
    }
    vm.currentCategory = vm.product.categoryid
    // vm.$refs.name.focus();

    vm.isLoadingBundle = true
    vm.getProductBundle(function(data) {
      vm.productbundle = data
      vm.isLoadingBundle = false
    })

    document.addEventListener('keydown', e => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })

    this.enableProductCost = this.allowBetaFeature('product_cost')
  },
  methods: {
    updateCategory(category) {
      this.productstockcategories = category
    },
    getProductBundle: function(callback) {
      let vm = this
      var data = {
        id: vm.product.id
      }

      api.getProductBundle(data, function(error, response) {
        if (error) {
          console.error(error)
          callback([])
          return
        }

        callback(response.productbundlelist)
      })
    },
    onChangeCategory: function(payload) {
      this.currentCategory = payload
    },
    saveProduct: async function() {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()

        return false
      }
      var product = cloneDeep(this.product)

      product.productstock = []

      var deleteStock = []

      if (this.$store.state.centralPage.includes(this.selectedBot.pageid)) {
        var newProductStockId = []
        this.productstock.map(el => {
          if (el[0]) newProductStockId.push(el[0])
        })

        this.product.productstock.map(el => {
          if (el[0] && !newProductStockId.includes(el[0])) deleteStock.push(el[0])
        })
      }
      product.productstock = this.productstock.map(val => {
        return { ...val }
      })

      product.name = product.name.trim()
      // product.cost = parseFloat(product.cost)
      product.price = parseFloat(product.price)
      product.discountprice = parseFloat(product.discountprice)
      product.pageid = this.pageid
      product.photourl = this.productImages.join(';;')
      product.categoryid = this.currentCategory
      product.productstockcategories = JSON.stringify(this.productstockcategories)

      if (product.vat_types) product.vat_value = 7
      else product.vat_value = null

      this.$store.dispatch('loading')
      try {
        await this.editProduct(product)

        await this.saveStock(deleteStock)
        if (this.$store.getters.getPackage === 'premium') {
          await this.saveBundle()
        }
        this.completeSaveProduct(product)
      } catch (error) {
        this.$store.dispatch('loading')
        console.error(error)
      }
    },
    async editProduct(product) {
      return new Promise((resolve, reject) => {
        api.editProduct(product, function(error, response) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    completeSaveProduct: function(product) {
      this.cached_product = JSON.stringify(product)
      this.cached_productstock = JSON.stringify(this.productstock)

      this.$emit('input', product)
      this.$emit('onSaveProduct')
    },
    saveStock: async function() {
      let vm = this

      try {
        let new_stocks = this.productstock.filter(el => el[0] == null)
        let new_stock_response = []
        if (new_stocks.length > 0) {
          new_stock_response = await this.saveProductStock(new_stocks)
        }

        let edit_stocks = this.productstock.filter(el => el[0] != null)
        let edit_stock_response = []
        if (edit_stocks.length > 0) {
          edit_stock_response = await this.editProductStock(edit_stocks)
        }

        try {
          let newStock = this.productstock.map(el => el[0])

          var deleteList = this.oldStock.filter(el => {
            return !newStock.includes(el)
          })

          if (deleteList.length > 0) {
            deleteList = deleteList.map(el => {
              return { id: el }
            })

            await vm.deleteProductStock(deleteList)
          }
        } catch (error) {
          console.error(error)
        }

        this.productstock = [...new_stock_response, ...edit_stocks]
      } catch (error) {
        console.error(error)
      }
    },
    formatStock(productid, value, index) {
      return {
        id: value[0],
        option: value[1],
        productid: productid,
        quantity: value[2],
        sku: value[5] ? value[5] : '',
        orders: index,
        photourl: value[7] && value[7] != 'null' ? value[7] : null,
        weight: value[8] ? value[8] : null,
        // cost: value[9] === '' || parseFloat(value[9]) === 0 ? null : value[9],
        price: value[3] === '' || parseFloat(value[3]) === 0 ? null : value[3],
        discountprice: value[4] === '' || parseFloat(value[4]) === 0 ? null : value[4]
      }
    },
    saveProductStock(stocks) {
      let format_stock = stocks.map((el, index) => {
        return this.formatStock(this.product.id, el, index)
      })
      return new Promise((resolve, reject) => {
        api.post_productstock_batch(
          {
            body: {
              productstock_obj: format_stock
            }
          },
          function(error, response) {
            if (error) {
              reject(error)
            }

            if (response.productstock_obj && response.productstock_obj.length == stocks.length) {
              let new_stocks = stocks.map((el, index) => {
                el[0] = response.productstock_obj[index].id
              })
              resolve(new_stocks)
            } else {
              resolve([])
            }
          }
        )
      })
    },
    editProductStock(stocks) {
      let format_stock = stocks.map((el, index) => {
        return this.formatStock(this.product.id, el, index)
      })
      return new Promise((resolve, reject) => {
        api.put_productstock_batch(
          {
            body: {
              productstock_obj: format_stock
            }
          },
          function(error, response) {
            if (error) {
              reject(error)
            }
            if (response.responsecode == 200) resolve(stocks)
            else resolve([])
          }
        )
      })
    },
    deleteProductStock(stocks) {
      return new Promise((resolve, reject) => {
        api.delete_productstock_batch({ body: { productstock_obj: stocks } }, function(
          error,
          response
        ) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    saveBundle: async function() {
      let vm = this

      var bundles = []
      try {
        bundles = vm.productbundle.map(bundle => {
          bundle.productid = vm.product.id
          return bundle
        })

        var save_bundles = bundles.filter(el => el.id == null)
        let save_bundles_response = []
        if (save_bundles.length > 0) {
          save_bundles_response = await this.saveProductBundle(save_bundles)
        }

        var edit_bundles = bundles.filter(el => el.id != null)
        let edit_bundles_response = []
        if (edit_bundles.length > 0) {
          edit_bundles_response = await this.editProductBundle(edit_bundles)
        }

        vm.productbundle = [...save_bundles_response, ...edit_bundles_response]
      } catch (error) {
        console.error(error)
      }

      try {
        var delete_bundles = vm.deleteBundleList.map(val => {
          return {
            id: val
          }
        })
        if (delete_bundles.length > 0) await this.deleteProductBundle(delete_bundles)
      } catch (error) {
        console.error(error)
      }
    },
    saveProductBundle(bundles) {
      return new Promise((resolve, reject) => {
        api.post_productbundle_batch(
          {
            body: {
              productbundle_obj: bundles
            }
          },
          function(error, response) {
            if (error) {
              reject(error)
            }

            if (response.productbundle_ids && response.productbundle_ids.length == bundles.length) {
              let new_bundles = bundles.map((el, index) => {
                return {
                  ...el,
                  id: response.productbundle_ids[index].id
                }
              })
              resolve(new_bundles)
            } else {
              resolve([])
            }
          }
        )
      })
    },
    editProductBundle(bundles, index) {
      return new Promise((resolve, reject) => {
        api.put_productbundle_batch(
          {
            body: {
              productbundle_obj: bundles
            }
          },
          function(error, response) {
            if (error) reject(error)
            resolve(response)
          }
        )
      })
    },
    deleteProductBundle(bundle) {
      return new Promise((resolve, reject) => {
        api.delete_productbundle_batch({ body: { productbundle_obj: bundle } }, function(
          error,
          response
        ) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },

    deleteStock: function(id) {
      this.deleteStockList.push(id)
    },
    deleteBundle: function(id) {
      this.deleteBundleList.push(id)
    },
    checkTag: function(obj) {
      this.errorTag = []
      if (this.tags.map(t => t.text).indexOf(obj.tag.text) !== -1) {
        this.errorTag.push('duplicate')
      } else obj.addTag()
    },
    onDeleteProduct: function(id) {
      if (confirm('Do you want to delete this?')) {
        let vm = this
        vm.$store.dispatch('loading')
        api.deleteProduct(id, function(error, response) {
          if (error) {
            vm.$store.dispatch('loading')
            console.error(error)
            return
          }

          vm.$emit('productDeleted')
          vm.$emit('close')
          vm.$store.dispatch('loading')
        })
      }
    },
    cancelContent: function() {
      var vm = this
      vm.product = JSON.parse(vm.cached_product)
      vm.productstock = JSON.parse(vm.cached_productstock)
      vm.productImages = vm.product.photourl ? vm.product.photourl.split(';;') : []

      vm.$emit('close')
    },
    onChangePrice: function() {
      this.$set(this.product, 'discountprice', this.product.price)
    }
  },
  watch: {
    value: async function(newVal, oldVal) {
      let vm = this
      vm.product = cloneDeep(newVal)
      vm.product.buttonaction = 'url'
      vm.cached_product = JSON.stringify(vm.product)

      vm.loadingProductStock = true
      vm.productstock = []
      var productstock = vm.value.productstock.map(el => {
        return [...el]
      })
      this.oldStock = vm.value.productstock.map(el => {
        return el[0]
      })
      vm.productstock = productstock
      await vm.$nextTick()
      vm.loadingProductStock = false
      vm.cached_productstock = JSON.stringify(vm.value.productstock)
      vm.currentCategory = vm.product.categoryid

      vm.productImages = vm.product.photourl ? vm.product.photourl.split(';;') : []

      vm.isLoadingBundle = true
      vm.getProductBundle(function(data) {
        vm.productbundle = data
        vm.isLoadingBundle = false
      })
    }
  }
}
</script>

<style scroped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ModalEditProduct.vue